var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppSelect',_vm._g(_vm._b({attrs:{"value":_vm.value,"options":_vm.cities,"loading":_vm.loading,"remote-search":_vm.suggestCities,"remote-search-text":"Введите название города","clearable":""}},'AppSelect',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }